import styled from 'styled-components';

const IndividualTopSectionStyle = styled.div`
	&.individual-top-section-container-wrap {
		margin-top: calc(-1 * var(--headerHeight));
		margin-bottom: var(--sp8x);

		&.underline {
			.flexCont {
				padding-bottom: var(--sp8x);
				border-bottom: 2px solid var(--color2);
			}
		}

		.topImg {
			padding-top: 100%;
		}

		.flexCont {
			padding-top: var(--sp3x);

			.title {
				margin-bottom: var(--sp4x);
			}

			.otherOptionWrap {
				.otherOptionItemCont {
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;
					margin-left: calc(-1 * var(--sp1x));
					margin-right: calc(-1 * var(--sp1x));

					.otherOptionItem {
						width: 50%;
						margin-bottom: var(--sp4x);
						padding-left: var(--sp1x);
						padding-right: var(--sp1x);

						.otherOptionTitle {
							margin-bottom: var(--sp2-5x);
						}

						.otherOption {
							margin-bottom: var(--sp1x);

							&:last-child {
								margin-bottom: 0;
							}
						}

						&:last-child {
							margin-bottom: 0;
						}
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
			.flexCont {
				padding-top: var(--sp4x);

				.otherOptionWrap {
					.otherOptionItem {
						margin-bottom: var(--sp6x);
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.flexCont {
				.otherOptionWrap {
					display: flex;

					.otherOptionItemCont {
						.otherOptionItem {
							margin-bottom: 0;
							width: calc(33.33% - var(--sp2-5x));

							.otherOption {
								&:last-child {
									margin-bottom: 0;
								}
							}
						}
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.flexCont {
				.title {
					margin-bottom: var(--sp6x);
				}

				.otherOptionWrap {
					justify-content: flex-end;

					.otherOptionItemCont {
						width: 65%;
					}
				}
			}

			.topImg {
				padding-top: 89%;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			&.underline {
				.flexCont {
					padding-bottom: var(--sp6x);
				}
			}

			.flexCont {
				display: flex;

				.title {
					width: 50%;
					padding-right: var(--sp4x);
					margin-bottom: 0;
				}

				.otherOptionWrap {
					width: 50%;

					.otherOptionItemCont {
						width: 100%;
						margin-top: calc(var(--h5) - var(--pM));
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			.topImg {
				padding-top: 45%;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			.topImg {
				padding-top: 41%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			.flexCont {
				.otherOptionWrap {
					.otherOptionItemCont {
						.otherOptionItem {
							.otherOptionTitle {
								margin-bottom: var(--sp3x);
							}
						}
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			margin-bottom: var(--sp5x);

			&.underline {
				.flexCont {
					padding-bottom: var(--sp6x);
				}
			}

			.flexCont {
				padding-top: var(--sp5x);
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			&.underline {
				.flexCont {
					padding-bottom: var(--sp10x);
				}
			}

			.flexCont {
				padding-top: var(--sp8x);

				.otherOptionWrap {
					.otherOptionItemCont {
						.otherOptionItem {
							.otherOptionTitle {
								margin-bottom: var(--sp4x);
							}
						}
					}
				}
			}
		}
	}
`;

export default IndividualTopSectionStyle;
